import { render, staticRenderFns } from "./CompareLoansItem.vue?vue&type=template&id=028bd2da&scoped=true&"
import script from "./CompareLoansItem.vue?vue&type=script&lang=js&"
export * from "./CompareLoansItem.vue?vue&type=script&lang=js&"
import style0 from "./CompareLoansItem.vue?vue&type=style&index=0&id=028bd2da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028bd2da",
  null
  
)

export default component.exports